import 'tslib';
import 'long';
import '../proto/index.js';
import { ErrorType } from '../core/consts.js';
import { Logger } from '../core/metrics/logger.js';
import { BaseError } from '../core/errors/BaseError.js';
import '../core/metrics/monitor.js';
import '../core/network/NetworkItem.js';
import { ContextClassBase } from '../core/service/RuntimeContext.js';
import { Subject } from '../core/events/Subject.js';
import 'json-long';
import 'moize';
import '../core/model/Message.js';
import 'js-md5';
import '../core/utils/lz4.js';
import '../core/utils/serializer.js';
import '../adapter/manager/AdapterManager.js';
import '../adapter/manager/types.js';
import '../core/utils/ticker.js';
import '../adapter/abstract/IMNetApi.js';
import '../core/options.js';
import '../core/utils/uuid.js';
import '../core/service/ConversationManager.js';
import '../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../core/plugin/DbProxy.js';
import '../core/metrics/trackerTypes.js';
import '../core/model/CommandMessage.js';

var RtcEvent;
(function (RtcEvent) {
    RtcEvent["ManagerReset"] = "manager-reset";
    RtcEvent["StartCall"] = "start-call";
    RtcEvent["CancelCall"] = "cancel-call";
    RtcEvent["CallTimeout"] = "call-timeout";
    RtcEvent["CalleeOccupied"] = "callee-occupied";
    RtcEvent["CalleeRinging"] = "callee-ringing";
    RtcEvent["CalleeAccept"] = "callee-accept";
    RtcEvent["CalleeDeny"] = "callee-deny";
    RtcEvent["Terminated"] = "terminated";
    RtcEvent["SelfOccupied"] = "self-occupied";
    RtcEvent["SelfRinging"] = "self-ringing";
    RtcEvent["SelfAccept"] = "self-accept";
    RtcEvent["SelfDeny"] = "self-deny";
    RtcEvent["SelfTeminate"] = "self-terminate";
    RtcEvent["CallCanceled"] = "call-canceled";
    RtcEvent["RingFail"] = "ring-fail";
    RtcEvent["SelfOtherDeviceOccupied"] = "self-other-device-occupied";
    RtcEvent["SelfOtherDeviceAccpet"] = "self-other-device-accept";
    RtcEvent["SelfOtherDeviceDeny"] = "self-other-device-deny";
    RtcEvent["ChatTypeChanged"] = "chat-type-changed";
    RtcEvent["StreamPublished"] = "stream-published";
    RtcEvent["StreamAdded"] = "stream-added";
    RtcEvent["StreamSubscribed"] = "stream-subscribed";
    RtcEvent["StreamRemoved"] = "stream-removed";
    RtcEvent["MuteAudio"] = "mute-audio";
    RtcEvent["UnmuteAudio"] = "unmute-audio";
    RtcEvent["MuteVideo"] = "mute-video";
    RtcEvent["UnmuteVideo"] = "unmute-video";
    RtcEvent["ClientBanned"] = "client-banned";
    RtcEvent["PeerOnline"] = "peer-online";
    RtcEvent["PeerLeave"] = "peer-leave";
    RtcEvent["TokenRequest"] = "token-request";
    RtcEvent["CameraChanged"] = "camera-changed";
    RtcEvent["RecordingDeviceChanged"] = "recording-device-changed";
    RtcEvent["PlayoutDeviceChanged"] = "playout-device-changed";
    RtcEvent["ConnectionStateChange"] = "connection-state-change";
    RtcEvent["NetworkTypeChanged"] = "network-type-changed";
})(RtcEvent || (RtcEvent = {}));
class RtcEventBus extends ContextClassBase {
    constructor() {
        super(...arguments);
        this.subscriptions = new Map();
    }
    subscribe(event, func) {
        if (!(Object.values(RtcEvent).includes(event))) {
            throw new BaseError({
                ctx: this.ctx,
                type: ErrorType.InvalidParam,
                msg: `unknown rtc event: ${event}`,
                sender: this
            });
        }
        if (!this.subscriptions.has(event)) {
            this.subscriptions.set(event, new Subject(this.ctx));
        }
        const subject = this.subscriptions.get(event);
        Logger.ctxDebug(this.ctx, `subscribe rtc event "${event}"`);
        return subject.subscribe(func);
    }
    /** @internal */
    emit(event, sender, e) {
        const subject = this.subscriptions.get(event);
        if (subject) {
            subject.next(e, sender);
        }
    }
    /**
     * 取消一个事件订阅
     * @param event 事件类型
     * @param handler 回调函数 Index
     */
    unsubscribe(event, handler) {
        if (!this.subscriptions.has(event)) {
            return;
        }
        this.subscriptions.get(event).unsubscribe(handler);
    }
    /** @internal */
    unsubscribeAll() {
        for (const sub of Object.values(this.subscriptions)) {
            sub.unsubscribeAll();
        }
        this.subscriptions.clear();
    }
}

export { RtcEvent, RtcEventBus };
//# sourceMappingURL=RtcEvent.js.map
